import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

/*
 * @Author: Nanxing Xiang
 * @Date: 2021-03-18 10:04:45
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2022-01-20 10:55:09
 * @Description: file content
 */
import React, { useEffect, useState } from 'react';

var EasTabItem = function EasTabItem(_ref) {
  var _context, _context2;

  var index = _ref.index,
      current = _ref.current,
      children = _ref.children,
      className = _ref.className,
      lazyload = _ref.lazyload,
      animation = _ref.animation;

  var _useState = useState(!lazyload),
      _useState2 = _slicedToArray(_useState, 2),
      render = _useState2[0],
      setRender = _useState2[1];

  var _useState3 = useState(current === index ? 'show' : 'none'),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1];

  useEffect(function () {
    if (current === index) {
      setState('show');
      return function () {
        if (animation === false) {
          setState('none');
        } else {
          setState('hide');
          setTimeout(function () {
            setState('none');
          }, 400);
        }
      };
    }

    return function () {};
  }, [animation, current, index]);
  useEffect(function () {
    if (index === current) {
      setRender(true);
    }
  }, [current, index]);
  return React.createElement("div", {
    className: _concatInstanceProperty(_context = "eas__tab-item ".concat(className, " ")).call(_context, state),
    style: animation === false ? {} : {
      transition: 'opacity 0.3s ease-in-out'
    }
  }, render && _mapInstanceProperty(_context2 = React.Children).call(_context2, children, function (child) {
    return child;
  }));
};

export default React.memo(EasTabItem);